export default __webpack_public_path__ + "static/media/choices1.b0f0dce6.webp";